import { css } from '@emotion/css';
import { BooleanSelect, Checkbox, Text } from 'Shared/forms/Inputs'
import { LabelOnLeftWrap, LabelOnRightWrap, Wrap } from 'Shared/forms/Wrap'
import { optionList } from 'Shared/backend/widgets/ComponentOptions';
import { IntegratedSelectorAndComponent } from 'Shared/backend/widgets/IntegratedSelectorAndComponent';
import { LinkLayout } from 'Shared/model/Components';
import { fieldsToKeep } from 'Shared/backend/widgets/CreationUtils';
import { NestedLinkWarning } from 'Shared/backend/widgets/NestedLinkWarning';
import { Match, Switch } from 'solid-js';


export function initLink(old?:any)
{
	const {content} = fieldsToKeep(old);
	return {layout:'link',content};
}


export function LinkBlock(P:LinkLayout)
{
	const options = optionList([],['popup']);

	const detailsStyle = css({
		display: 'flex',
		flexDirection: 'column',
		gap: '0.8em',
	});

	return (
		<div class={detailsStyle}>
			<LabelOnLeftWrap label='Link / Anchor'>
				<BooleanSelect field='isAnchor' options={{false:'Link',true:'Anchor'}} />
			</LabelOnLeftWrap>

			<Switch>
				<Match when={P.isAnchor}>
					<Wrap label='Anchor'>
						<Text field='anchor' />
					</Wrap>
				</Match>
				<Match when={true}>
					<NestedLinkWarning />

					<Wrap label='Link'>
						<Text field='link' placeholder='eg https://webaddress | page title for your own site eg /contact'/>
					</Wrap>

					<LabelOnRightWrap label='Open link on the same window'>
						<Checkbox field='openInSameWindow' initialValue={false} />
					</LabelOnRightWrap>

					<IntegratedSelectorAndComponent {...P.content} label='Component' contentFieldName='content' options={options} required />
				</Match>
			</Switch>
		</div>
	);
}

